import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";

import {
  UserOutlined,
  MailOutlined,
  ScheduleOutlined,
  EnvironmentOutlined,
  BankOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

import { Avatar, Segmented } from "antd";

import paypallogo from "../../img/paypal.png";
import zellelogo from "../../img/zelle.webp";
import banklogo from "../../img/bank.png";
import { Input } from "antd";

import { Modal } from "antd";
import { message } from "antd";

function BillingRow(props) {
  const textColor = useColorModeValue("gray.700", "white");
  const bgColor = useColorModeValue("#F8F9FA", "navy.900");
  const nameColor = useColorModeValue("gray.500", "white");
  const { name, company, email, number, address, id, actualizarcuenta } = props;

  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");
  const [selectedOption, setSelectedOption] = useState(name); // Valor predeterminado

  const [messageApi, contextHolder] = message.useMessage();

  const [cuenta, setCuenta] = useState(email);
  const [rutabancaria, setRutabancaria] = useState(company);
  const [direccion, setDireccion] = useState(address);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Account successfully deleted",
    });
  };

  const success_update = () => {
    messageApi.open({
      type: "success",
      content: "Account successfully updated",
    });
  };

  const error_empty = () => {
    messageApi.open({
      type: "error",
      content: "Complete the form",
    });
  };

  const error_email_invalid = () => {
    messageApi.open({
      type: "error",
      content: "Enter a valid Email",
    });
  };

  const deleteaccount = (id) => {
    const data = {
      token: localStorage.getItem("token_royal"),
      id: id,
    };
    fetch(`${process.env.REACT_APP_API}/deletecuentaswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.message == "eliminado") {
            actualizarcuenta("actualizar");
            success();
            console.log("ELIMINADO");
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setConfirmLoading(true);

    let type_error = "";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (selectedOption == "Paypal" || selectedOption == "Zelle") {
      if (cuenta == "") {
        type_error = "vacio";
      } else if (!emailRegex.test(cuenta)) {
        type_error = "email";
      }
    }

    if (selectedOption == "Bank") {
      if (cuenta == "" || rutabancaria == "" || direccion == "") {
        type_error = "vacio";
      }
    }

    if (type_error === "vacio") {
      error_empty();
      setConfirmLoading(false);
      return;
    }

    if (type_error === "email") {
      console.log(type_error);
      error_email_invalid();
      setConfirmLoading(false);
      return;
    }

    const data = {
      token: localStorage.getItem("token_royal"),
      id: id,
      cuenta: cuenta,
      ruta_bancaria: rutabancaria,
      direccion: direccion,
    };
    fetch(`${process.env.REACT_APP_API}/updatecuentaswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          if (result.message == "modificado") {
            success_update();
            setConfirmLoading(false);
            setOpen(false);
            actualizarcuenta("actualizar");
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  const handleSegmentChange = (value) => {
    console.log("Selected Payment Method:", value);
    setSelectedOption(value);
  };

  return (
    <Box p="24px" bg={bgColor} my="22px" borderRadius="12px">
      {contextHolder}
      <Flex justify="space-between" w="100%">
        <Flex direction="column" maxWidth="70%">
          <Text color={nameColor} fontSize="md" fontWeight="bold" mb="10px">
            {name}
          </Text>
          {name == "Bank" ? (
            <Text color="gray.400" fontSize="sm" fontWeight="semibold">
              Company Name:{" "}
              <Text as="span" color={nameColor}>
                {company}
              </Text>
            </Text>
          ) : (
            <></>
          )}
          {name !== "Bank" ? (
            <Text color="gray.400" fontSize="sm" fontWeight="semibold">
              Email Address:{" "}
              <Text as="span" color={nameColor}>
                {email}
              </Text>
            </Text>
          ) : (
            <></>
          )}

          {name == "Bank" ? (
            <Text color="gray.400" fontSize="sm" fontWeight="semibold">
              Account Number:{" "}
              <Text as="span" color={nameColor}>
                {number}
              </Text>
            </Text>
          ) : (
            <></>
          )}
          {name == "Bank" ? (
            <Text color="gray.400" fontSize="sm" fontWeight="semibold">
              Address:{" "}
              <Text as="span" color={nameColor}>
                {address}
              </Text>
            </Text>
          ) : (
            <></>
          )}
        </Flex>
        <Flex
          direction={{ sm: "column", md: "row" }}
          align="flex-start"
          p={{ md: "24px" }}
        >
          <Button
            p="0px"
            bg="transparent"
            variant="no-effects"
            mb={{ sm: "10px", md: "0px" }}
            me={{ md: "12px" }}
            onClick={() => {
              Modal.confirm({
                title: "Desea Eliminar Esta Cuenta",
                content: email,
                onOk: () => {
                  deleteaccount(id);
                },
                onCancel: () => {
                  console.log("El usuario hizo clic en Cancelar");
                },
                footer: (_, { OkBtn, CancelBtn }) => (
                  <>
                    <CancelBtn />
                    <OkBtn />
                  </>
                ),
              });
            }}
          >
            <Flex color="red.500" cursor="pointer" align="center" p="12px">
              <Icon as={FaTrashAlt} me="4px" />
              <Text fontSize="sm" fontWeight="semibold">
                DELETE
              </Text>
            </Flex>
          </Button>
          <Button
            p="0px"
            bg="transparent"
            variant="no-effects"
            onClick={showModal}
          >
            <Flex color={textColor} cursor="pointer" align="center" p="12px">
              <Icon as={FaPencilAlt} me="4px" />
              <Text fontSize="sm" fontWeight="semibold">
                EDIT
              </Text>
            </Flex>
          </Button>
          <Modal
            title="Account Registration"
            open={open}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            okText="Edit Account"
          >
            <Segmented
              options={[
                {
                  label: (
                    <div style={{ padding: 4 }}>
                      {name == "Paypal" ? (
                        <img src={paypallogo} width="30px" />
                      ) : (
                        <></>
                      )}
                      {name == "Zelle" ? (
                        <img src={zellelogo} width="30px" />
                      ) : (
                        <></>
                      )}
                      {name == "Bank" ? (
                        <img src={banklogo} width="30px" />
                      ) : (
                        <></>
                      )}

                      <div>{name}</div>
                    </div>
                  ),
                  value: { name },
                },
              ]}
              onChange={handleSegmentChange} // Maneja el cambio
              defaultValue={name}
              value={name}
            />
            {name == "Paypal" ? (
              <div>
                <br />
                <div align="center" style={{ fontSize: "14px" }}>
                  <strong>Account PayPal</strong>
                </div>

                <span style={{ fontSize: "14px", marginTop: "10px" }}>
                  Please enter your PayPal:
                </span>
                <Input
                  size="large"
                  placeholder="Email"
                  defaultValue={cuenta}
                  onChange={(e) => setCuenta(e.target.value)}
                  prefix={<MailOutlined />}
                />
              </div>
            ) : (
              <></>
            )}
            {name == "Zelle" ? (
              <div>
                <br />
                <div align="center" style={{ fontSize: "14px" }}>
                  <strong>Account Zelle</strong>
                </div>

                <span style={{ fontSize: "14px", marginTop: "10px" }}>
                  Please enter your Zelle:
                </span>
                <Input
                  size="large"
                  defaultValue={cuenta}
                  placeholder="Email"
                  onChange={(e) => setCuenta(e.target.value)}
                  prefix={<ScheduleOutlined />}
                />
              </div>
            ) : (
              <></>
            )}
            {name == "Bank" ? (
              <div>
                <br />
                <div align="center" style={{ fontSize: "14px" }}>
                  <strong>Account Bank</strong>
                </div>

                <span style={{ fontSize: "14px", marginTop: "10px" }}>
                  Bank Name:
                </span>
                <Input
                  size="large"
                  placeholder="Bank Name"
                  onChange={(e) => setRutabancaria(e.target.value)}
                  defaultValue={rutabancaria}
                  prefix={<FileTextOutlined />}
                />
                <br />
                <span style={{ fontSize: "14px", marginTop: "15px" }}>
                  Account Number:
                </span>
                <Input
                  size="large"
                  placeholder="#"
                  defaultValue={cuenta}
                  onChange={(e) => setCuenta(e.target.value)}
                  prefix={<BankOutlined />}
                />
                <span style={{ fontSize: "14px", marginTop: "10px" }}>
                  Address:
                </span>
                <br />
                <Input
                  size="large"
                  placeholder="Address"
                  defaultValue={direccion}
                  onChange={(e) => setDireccion(e.target.value)}
                  prefix={<EnvironmentOutlined />}
                />
              </div>
            ) : (
              <></>
            )}
          </Modal>
        </Flex>
      </Flex>
    </Box>
  );
}

export default BillingRow;
